import React, { useState } from "react";
import { SlTab, SlTabGroup, SlTabPanel } from '@shoelace-style/shoelace/dist/react';
import { useDispatch } from 'react-redux';
import { roles } from "../../utils/constants";
import AdsPrices from "./AdsPrices";
import AgentDetails from "./AgentDetails"
import AdsDashboard from "./AdsDashboard"
import { SetComponentId } from '../../redux/counterSlice'

export const campCreativeContext = React.createContext();
function ReporterAds() {
    const dispatch = useDispatch();
    dispatch(SetComponentId(14))

    const [loader, setLoader] = useState(false);
    const [currentTab, setCurrentTab] = useState("ads_dashboard");
    const handleTabClick = (tabName) => {
        setCurrentTab(tabName);
    };

    return (
        <>
            <div className="card-body cc-body">
                <SlTabGroup>

                    {
                        localStorage.getItem("role") !== roles.advertiser &&
                        <>
                            {(localStorage.getItem("role") === roles.ops) ? (<SlTab slot="nav" panel="ads_dashboard" onClick={() => handleTabClick("ads_dashboard")}>
                                Ads Dashboard
                            </SlTab>) : null}
                            {(localStorage.getItem("role") === roles.ops) ? (<SlTab slot="nav" panel="agent_adv_details" onClick={() => handleTabClick("agent_adv_details")}>
                                Agent / Adv Details
                            </SlTab>) : null}
                            {(localStorage.getItem("role") === roles.ops) ? (<SlTab slot="nav" panel="reporter_ads_price_location" onClick={() => handleTabClick("reporter_ads_price_location")}>
                                Set price for Location
                            </SlTab>) : null}
                        </>}

                    <SlTabPanel name="ads_dashboard">
                        <div >
                            {(currentTab === "ads_dashboard") ?
                                (<div className="mb-4" >
                                    <AdsDashboard></AdsDashboard>
                                </div>) : null}
                        </div >

                    </SlTabPanel >

                    <SlTabPanel name="agent_adv_details">
                        <div >
                            {(currentTab === "agent_adv_details") ?
                                (<div className="mb-4" >
                                    <AgentDetails />
                                </div>) : null}
                        </div >

                    </SlTabPanel >

                    <SlTabPanel name="reporter_ads_price_location">
                        <div >
                            {(currentTab === "reporter_ads_price_location") ?
                                (<div className="mb-4" >
                                    <AdsPrices />
                                </div>) : null}
                        </div >

                    </SlTabPanel >

                </SlTabGroup >
            </div >
        </>
    )

}

export default ReporterAds;